import { useSessionState } from './useSessionState';

export type ReportViewMode = 'table' | 'matches';

const VALID_MODES = new Set<ReportViewMode>(['table', 'matches']);

export const useReportViewMode = (contextKey: string): [ReportViewMode, (mode: ReportViewMode) => void] => {
  const [mode, setMode] = useSessionState<ReportViewMode>(`reportViewMode:${contextKey}`, 'table');
  const validMode = VALID_MODES.has(mode) ? mode : 'table';
  return [validMode, setMode];
};
